import { axios } from '@/services/axios';

export const updateVoicePolicy = (voicePolicyData) => {
    return axios.put('/VoicePolicy', voicePolicyData);
};
